import styled from '@emotion/styled'
import { Button, Typography, Select, MenuItem, Grid } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

export const GridContainer = styled(Grid)({
  gap: '8px',
  padding: '24px',
  color: 'white'
})

export const ButtonCsvGenerate = styled(Button)(({ theme }) => ({
  borderRadius: '4px',
  color: 'black',
  marginTop: '35px',
  padding: '11px 20px 11px 24px',
  fontFamily: 'Nunito',
  fontSize: '14px',
  width: '175px',
  textTransform: 'capitalize',
  height: '32px',
  fontWeight: 700,
  backgroundColor: theme.palette.button.save.primary,
  '&:hover': {
    backgroundColor: theme.palette.button.save.hover
  },
  '&:disabled': {
    background: `${theme.palette.button.disable} !important`,
    color: theme.palette.svg.clearIcon
  }
}))

export const ButtonCsvGenerateText = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontFamily: 'Nunito',
  fontSize: '14px',
  textTransform: 'capitalize',
  fontWeight: 700,
  backgroundColor: 'transparent'
}))

export const OptionContainer = styled('li')(() => ({
  display: 'flex !important',
  justifyContent: 'space-between !important',
  '&:hover': {
    backgroundColor: 'black'
  }
}))

export const OptionCounterparty = styled('span')({
  color: '#D3D3D3',
  fontSize: '14px',
  fontStyle: 'italic',
  marginLeft: '4px'
})

export const StyledSelect = styled(Select)(({ theme, background = 'transparent' }) => ({
  color: `${theme.palette.text.primary} !important`,
  width: '100%',
  '& .MuiPaper-root': {
    padding: '0px',
    backgroundColor: `#242428 !important`,
    hight: '150px',
    '& ul': {
      padding: '0px !important',
      hight: '150px',
      backgroundColor: `#242428 !important`
    },
    '& .MuiInputBase-root': {
      background: `#242428 !important`
    }
  }
}))

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: 'white',
  display: 'flex',
  gap: '6px',
  fontFamily: 'Nunito',
  textTransform: 'capitalize',
  backgroundColor: `#242428 !important`,
  '&:hover': {
    backgroundColor: `#242428 !important`
  },
  '&.Mui-selected': {
    backgroundColor: '#242428 !important'
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#242428 !important'
  }
}))

export const StyledSelectArrowIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
  color: `${theme.palette.button.save.primary} !important`,
  marginRight: '2px'
}))

export const ButtonTradeType = styled(Button)(() => {
  let border = `1px solid #A4A4FF`
  let backgroundColor = 'transparent'

  return {
    border: border,
    backgroundColor: backgroundColor,
    borderRadius: '3px',
    padding: '11px 16px',
    color: '#A4A4FF',
    height: '32px',
    fontSize: '14px',
    fontFamily: 'Nunito',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#8C8CFF',
      border: border,
      borderColor: '#8C8CFF'
    }
  }
})
